// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be19b370","455":"f00eafb3","904":"f29fca8f"}[chunkId] + ".chunk.js";
};